import { render, staticRenderFns } from "./complaintDetail.vue?vue&type=template&id=556f2c5b&"
import script from "./complaintDetail.vue?vue&type=script&lang=js&"
export * from "./complaintDetail.vue?vue&type=script&lang=js&"
import style0 from "./complaintDetail.vue?vue&type=style&index=0&id=556f2c5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports